/**
 * Utilitários para manipulação de preços
 */

/**
 * Converte uma string de preço para número
 * @param {string|number} price - Preço em formato de string ou número
 * @returns {number} - Valor numérico do preço
 */
export const parsePrice = (price) => {
  if (!price) return 0;
  // Handle different possible formats
  let cleanPrice = price;
  if (typeof price === 'string') {
    cleanPrice = price.replace(/[^\d,\.]/g, '').replace(',', '.');
  }
  return parseFloat(cleanPrice) || 0;
};

/**
 * Formata um valor numérico para formato de preço brasileiro
 * @param {number} value - Valor numérico
 * @returns {string} - Preço formatado (ex: R$ 10,50)
 */
export const formatPrice = (value) => {
  return `R$ ${value.toFixed(2).replace('.', ',')}`;
};

/**
 * Calcula os preços para exibição
 * @param {string|number} monthlyValue - Valor mensal
 * @param {string|number} annualValue - Valor anual
 * @returns {object} - Objeto com os valores calculados
 */
export const calculatePrices = (monthlyValue, annualValue) => {
  const monthly = parsePrice(monthlyValue);
  const annual = parsePrice(annualValue);
  
  // Preço original (12 meses)
  const originalPrice = monthly * 12;
  
  // Economia ao escolher plano anual
  const savingsAmount = originalPrice - annual;
  
  return {
    monthly,
    annual,
    originalPrice,
    savingsAmount,
    formattedOriginalPrice: formatPrice(originalPrice),
    formattedMonthly: formatPrice(monthly),
    formattedAnnual: formatPrice(annual),
    formattedSavings: formatPrice(savingsAmount)
  };
};